import { allPlayers } from '../sampleData/all';
import { API, baseURL } from './api';

export const getLeaderboard = async () => {
	// let res = await API.get(`/score/all`);
	
	return allPlayers;
};

export const getPlayerdata = async (usertoken) => {
	// const requestOptions = {
	// 	method: 'GET',
	// 	headers: { 'x-access-token': usertoken },
	// };
	// let res = await fetch(`${baseURL}/playerdata`, requestOptions).catch(
	// 	async (e) => {
	// 		if (window.confirm('Something went wrong! Click OK to report.')) {
	// 			window.open('https://discord.gg/DG7UMRx22j', '_blank');
	// 		}
	// 		window.location.href = '/game';
	// 	}
	// );
	// res = await res.json();
	return {
		playerPenaltyPoints: 1,
		playerScore: 1780,
		currentTrack: [3, 3],
		code: 'S1',
	};
};

export const insertUser = async (usertoken) => {
	// const requestOptions = {
	// 	method: 'POST',
	// 	headers: { 'x-access-token': usertoken },
	// };
	// let res = await fetch(`${baseURL}/insert/user`, requestOptions).catch(
	// 	async (e) => {
	// 		if (window.confirm('Something went wrong! Click OK to report.')) {
	// 			window.open('https://discord.gg/DG7UMRx22j', '_blank');
	// 		}
	// 		window.location.href = '/game';
	// 	}
	// );
	localStorage.setItem('userCreated', true);
	return true;
};

export const getMap = async (usertoken) => {
	// const requestOptions = {
	// 	method: 'POST',
	// 	headers: { 'x-access-token': usertoken },
	// };

	// let res = await fetch(`${baseURL}/map`, requestOptions).catch(async (e) => {
	// 	if (window.confirm('Something went wrong! Click OK to report.')) {
	// 		window.open('https://discord.gg/DG7UMRx22j', '_blank');
	// 	}
	// 	window.location.href = '/game';
	// });
	// res = await res.json();
	return {
		username: 'horcrux',
		portalNodes: {
			9: true,
			20: true,
			32: true,
		},
		solvedNodes: [
			39, 17, 18, 19, 20, 32, 9, 8, 5, 1, 37, 2, 6, 7, 36, 35, 31, 30, 29,
			38,
		],
		unlockedNodes: [26, 25, 33, 3, 34, 10, 16, 15, 22, 21],
		lockedNode: 26,
		code: 'S1',
	};
};

export const getQuestion = async (usertoken, qid) => {
	// const requestOptions = {
	// 	method: 'POST',
	// 	headers: {
	// 		'x-access-token': usertoken,
	// 		'Content-Type': 'application/json',
	// 	},
	// 	body: JSON.stringify({ quesId: qid }),
	// };

	// let res = await fetch(`${baseURL}/ques`, requestOptions).catch(
	// 	async (e) => {
	// 		if (window.confirm('Something went wrong! Click OK to report.')) {
	// 			window.open('https://discord.gg/DG7UMRx22j', '_blank');
	// 		}
	// 		window.location.href = '/game';
	// 	}
	// );
	// res = await res.json();
	return {
		question: {
			img: [],
			links: [
				'https://open.spotify.com/playlist/13xNuRLSN3rAvmbGfKzbJx?si=fce89d9f73234e03',
			],
			text: 'Hand over the AUX and this is what I’ll play. Beth Emhoff’s love for it has been going down and down for a few years. My love for it, however, goes in the opposite direction.\nWho is the mathematical militant?',
		},
		hint: {
			img: ['https://i.imgur.com/9QCxnRk.png'],
			links: [],
			text: '',
		},
		track: [3, 3],
	};
};

export const submitAnswer = async (usertoken, qId, answer) => {
	// const requestOptions = {
	// 	method: 'POST',
	// 	headers: {
	// 		'x-access-token': usertoken,
	// 		'Content-Type': 'application/json',
	// 	},
	// 	body: JSON.stringify({ quesId: qId, answer: answer }),
	// };

	// let res = await fetch(`${baseURL}/submit`, requestOptions).catch(
	// 	async (e) => {
	// 		if (window.confirm('Something went wrong! Click OK to report.')) {
	// 			window.open('https://discord.gg/DG7UMRx22j', '_blank');
	// 		}
	// 		window.location.href = '/game';
	// 	}
	// );
	// res = await res.json();
	return Math.floor(Math.random() * 2) === 1
		? { code: 'L3' }
		: { code: 'S2' };
};

export const getHint = async (usertoken, qId) => {
	// const requestOptions = {
	// 	method: 'POST',
	// 	headers: {
	// 		'x-access-token': usertoken,
	// 		'Content-Type': 'application/json',
	// 	},
	// 	body: JSON.stringify({ quesId: qId }),
	// };

	// let res = await fetch(`${baseURL}/hint`, requestOptions).catch(
	// 	async (e) => {
	// 		if (window.confirm('Something went wrong! Click OK to report.')) {
	// 			window.open('https://discord.gg/DG7UMRx22j', '_blank');
	// 		}
	// 		window.location.href = '/game';
	// 	}
	// );
	// res = await res.json();
	return {
		hintpoints: 40,
		code: 'S1',
	};
};

export const penaltyPoint = async (usertoken, qId) => {
	// const requestOptions = {
	// 	method: 'POST',
	// 	headers: {
	// 		'x-access-token': usertoken,
	// 		'Content-Type': 'application/json',
	// 	},
	// 	body: JSON.stringify({ quesId: qId }),
	// };

	// let res = await fetch(`${baseURL}/penalty`, requestOptions).catch(
	// 	async (e) => {
	// 		if (window.confirm('Something went wrong! Click OK to report.')) {
	// 			window.open('https://discord.gg/DG7UMRx22j', '_blank');
	// 		}
	// 		window.location.href = '/game';
	// 	}
	// );
	// res = await res.json();
	return { code: 'L3' };
};

export const getHintPoints = async (usertoken) => {
	// const requestOptions = {
	// 	method: 'POST',
	// 	headers: {
	// 		'x-access-token': usertoken,
	// 		'Content-Type': 'application/json',
	// 	},
	// };

	// let res = await fetch(`${baseURL}/hintpoints`, requestOptions);
	// res = await res.json();
	return {
		hintpoints: 40,
		code: 'S1',
	};
};
